import { render, staticRenderFns } from "./IconNotification.vue?vue&type=template&id=25f08cbc&scoped=true&functional=true&"
import script from "./IconNotification.vue?vue&type=script&lang=ts&"
export * from "./IconNotification.vue?vue&type=script&lang=ts&"
import style0 from "./IconNotification.vue?vue&type=style&index=0&id=25f08cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "25f08cbc",
  null
  
)

export default component.exports